export default function (el) {
	function mostrar() {
		document.getElementById('divcpf').style.display = 'block';
	}
}
